import { render, staticRenderFns } from "./MapPolygonEditorDialog.vue?vue&type=template&id=7c704b8f&scoped=true&"
import script from "./MapPolygonEditorDialog.vue?vue&type=script&lang=js&"
export * from "./MapPolygonEditorDialog.vue?vue&type=script&lang=js&"
import style0 from "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css?vue&type=style&index=0&lang=css&"
import style1 from "./MapPolygonEditorDialog.vue?vue&type=style&index=1&id=7c704b8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c704b8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
